import React, { useState, useEffect } from 'react'
import { useParams, useNavigate, Link } from 'react-router-dom'
import { memberService } from '../../services/memberService'

function MemberDetail() {
  const { nba } = useParams()
  const navigate = useNavigate()
  const [member, setMember] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchMember()
  }, [nba])

  const fetchMember = async () => {
    try {
      setLoading(true)
      const response = await memberService.getById(nba)
      setMember(response.data.data)
    } catch (error) {
      console.error('Error fetching member:', error)
    } finally {
      setLoading(false)
    }
  }

  const formatDate = (dateStr) => {
    if (!dateStr) return '-'
    return new Date(dateStr).toLocaleDateString('id-ID')
  }

  const formatCurrency = (value) => {
    const num = parseFloat(value)
    if (isNaN(num)) return 'Rp 0'
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0
    }).format(num)
  }

  if (loading) {
    return (
      <div className="text-center py-5">
        <i className="fas fa-spinner fa-spin fa-2x"></i>
        <p className="mt-2">Memuat data...</p>
      </div>
    )
  }

  if (!member) {
    return (
      <div className="alert alert-warning">
        Anggota tidak ditemukan
      </div>
    )
  }

  return (
    <div>
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Detail Anggota</h3>
          <div className="card-tools">
            <button
              className="btn btn-default btn-sm"
              onClick={() => navigate('/members')}
            >
              <i className="fas fa-arrow-left mr-1"></i> Kembali
            </button>
          </div>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-3">
              {member.Photo && (
                <div className="text-center mb-3">
                  <img
                    src={member.Photo}
                    alt="Foto Anggota"
                    style={{ maxWidth: '150px', maxHeight: '200px', objectFit: 'cover', border: '1px solid #ddd' }}
                    className="rounded"
                  />
                </div>
              )}
            </div>
            <div className="col-md-9">
              <div className="row">
                <div className="col-md-6">
                  <table className="table table-borderless table-sm">
                    <tbody>
                      <tr>
                        <td width="150"><strong>UUID</strong></td>
                        <td>: {member.UUID || '-'}</td>
                      </tr>
                      <tr>
                        <td width="150"><strong>NBA</strong></td>
                        <td>: {member.NBA}</td>
                      </tr>
                      <tr>
                        <td><strong>Nama</strong></td>
                        <td>: {member.Nama}</td>
                      </tr>
                      <tr>
                        <td><strong>Tgl Masuk</strong></td>
                        <td>: {formatDate(member.TglMasuk)}</td>
                      </tr>
                      <tr>
                        <td><strong>Tgl Lahir</strong></td>
                        <td>: {formatDate(member.TglLahir)}</td>
                      </tr>
                      <tr>
                        <td><strong>Tempat Lahir</strong></td>
                        <td>: {member.TempatLahir || '-'}</td>
                      </tr>
                      <tr>
                        <td><strong>Jenis Kelamin</strong></td>
                        <td>: {member.JenisKelamin === 'L' ? 'Laki-laki' : member.JenisKelamin === 'P' ? 'Perempuan' : '-'}</td>
                      </tr>
                      <tr>
                        <td><strong>Status</strong></td>
                        <td>:
                          <span className={`badge ml-1 ${member.StatusAktif ? 'badge-success' : 'badge-warning'}`}>
                            {member.StatusAktif ? 'Aktif' : member.StatusAnggota}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td><strong>Cabang</strong></td>
                        <td>: {member.KodeCabang} - {member.NamaCabang || '-'}</td>
                      </tr>
                      <tr>
                        <td><strong>Lingkungan</strong></td>
                        <td>: {member.KodeLingkungan || '-'}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="col-md-6">
                  <table className="table table-borderless table-sm">
                    <tbody>
                      <tr>
                        <td width="150"><strong>Agama</strong></td>
                        <td>: {member.Agama || '-'}</td>
                      </tr>
                      <tr>
                        <td><strong>Status Perkawinan</strong></td>
                        <td>: {member.StatusPerkawinan || '-'}</td>
                      </tr>
                      <tr>
                        <td><strong>Pendidikan</strong></td>
                        <td>: {member.Pendidikan || '-'}</td>
                      </tr>
                      <tr>
                        <td><strong>Pekerjaan</strong></td>
                        <td>: {member.Pekerjaan || '-'}</td>
                      </tr>
                      <tr>
                        <td><strong>Tanggungan</strong></td>
                        <td>: {member.Tanggungan || 0}</td>
                      </tr>
                      <tr>
                        <td><strong>Nama Ibu Kandung</strong></td>
                        <td>: {member.NamaIbuKandung || '-'}</td>
                      </tr>
                      <tr>
                        <td><strong>No. HP</strong></td>
                        <td>: {member.MobileNo || '-'}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-12">
                  <table className="table table-borderless table-sm">
                    <tbody>
                      <tr>
                        <td width="150"><strong>Alamat</strong></td>
                        <td>: {member.Alamat || '-'}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <hr className="my-3" />

          <div className="row">
            <div className="col-md-12">
              <h5>Kartu Identitas</h5>
              <table className="table table-borderless table-sm">
                <tbody>
                  <tr>
                    <td width="150"><strong>Jenis Kartu</strong></td>
                    <td>: {member.JenisIDCard || '-'}</td>
                  </tr>
                  <tr>
                    <td><strong>Nomor Kartu</strong></td>
                    <td>: {member.NomorIDCard || '-'}</td>
                  </tr>
                  <tr>
                    <td><strong>Alamat Sesuai Kartu</strong></td>
                    <td>: {member.AlamatIDCard || '-'}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <hr className="my-3" />

          <div className="row">
            <div className="col-md-12">
              <h5>Ahli Waris</h5>
              <table className="table table-bordered table-sm">
                <thead>
                  <tr>
                    <th>Nama</th>
                    <th>Hubungan</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{member.AhliWaris1 || '-'}</td>
                    <td>{member.HubunganWaris1 || '-'}</td>
                  </tr>
                  {member.AhliWaris2 && (
                    <tr>
                      <td>{member.AhliWaris2}</td>
                      <td>{member.HubunganWaris2 || '-'}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <hr className="my-3" />

          <div className="row">
            <div className="col-md-12">
              <h5>Informasi Bank</h5>
              <table className="table table-borderless table-sm">
                <tbody>
                  <tr>
                    <td width="150"><strong>Nomor Rekening</strong></td>
                    <td>: {member.NomorRekening || '-'}</td>
                  </tr>
                  <tr>
                    <td><strong>Jenis Bank</strong></td>
                    <td>: {member.JenisBank || '-'}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <hr className="my-3" />

          <div className="row">
            <div className="col-md-6">
              <h5>Ringkasan Keuangan</h5>
              <table className="table table-sm">
                <tbody>
                  <tr>
                    <td>Simpanan Pokok</td>
                    <td className="text-right">{formatCurrency(member.TotalSimpananPokok)}</td>
                  </tr>
                  <tr>
                    <td>Simpanan Wajib</td>
                    <td className="text-right">{formatCurrency(member.TotalSimpananWajib)}</td>
                  </tr>
                  <tr>
                    <td>Simpanan Sukarela</td>
                    <td className="text-right">{formatCurrency(member.TotalSimpananSukarela)}</td>
                  </tr>
                  <tr className="table-primary">
                    <td><strong>Total Simpanan</strong></td>
                    <td className="text-right"><strong>
                      {formatCurrency(
                        (parseFloat(member.TotalSimpananPokok) || 0) +
                        (parseFloat(member.TotalSimpananWajib) || 0) +
                        (parseFloat(member.TotalSimpananSukarela) || 0)
                      )}
                    </strong></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="col-md-6">
              <h5>Informasi Tambahan</h5>
              <table className="table table-sm">
                <tbody>
                  <tr>
                    <td>Tgl Keluar</td>
                    <td className="text-right">{formatDate(member.TglKeluar)}</td>
                  </tr>
                  <tr>
                    <td>Dibuat</td>
                    <td className="text-right">{formatDate(member.CreatedAt)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {Array.isArray(member.simpanan) && member.simpanan.length > 0 && (
            <div className="mt-4">
              <h5>Daftar Simpanan</h5>
              <table className="table table-bordered table-sm">
                <thead className="thead-light">
                  <tr>
                    <th>No. Rekening</th>
                    <th>Jenis</th>
                    <th>Saldo</th>
                    <th>Status</th>
                    <th>Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {member.simpanan.map((s) => (
                    <tr key={s.NoRekening}>
                      <td>{s.NoRekening}</td>
                      <td>{s.KodeJenis}</td>
                      <td className="text-right">{formatCurrency(s.Saldo)}</td>
                      <td>
                        <span className={`badge ${s.Status === 'Aktif' ? 'badge-success' : 'badge-secondary'}`}>
                          {s.Status}
                        </span>
                      </td>
                      <td>
                        <Link to={`/savings/${s.NoRekening}`} className="btn btn-info btn-sm">
                          <i className="fas fa-eye"></i>
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {Array.isArray(member.pinjaman) && member.pinjaman.length > 0 && (
            <div className="mt-4">
              <h5>Daftar Pinjaman</h5>
              <table className="table table-bordered table-sm">
                <thead className="thead-light">
                  <tr>
                    <th>No. Pinjaman</th>
                    <th>Plafond</th>
                    <th>Sisa Pokok</th>
                    <th>Tenor</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(member.pinjaman) && member.pinjaman.length > 0 ? (
                    member.pinjaman.map((p) => (
                      <tr key={p.NoPinjaman}>
                        <td>{p.NoPinjaman}</td>
                        <td className="text-right">{formatCurrency(p.Plafond)}</td>
                        <td className="text-right">{formatCurrency(p.SisaPokok)}</td>
                        <td>{p.SisaTenor} / {p.Tenor} bulan</td>
                        <td>
                          <span className={`badge ${
                            p.Status === 'Aktif' ? 'badge-primary' :
                            p.Status === 'Lunas' ? 'badge-success' :
                            'badge-secondary'
                          }`}>
                            {p.Status}
                          </span>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center">Belum ada pinjaman</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default MemberDetail
